import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef, Input , EventEmitter, Output} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule , FormControl } from '@angular/forms';
import { NotificationService } from '../../../services/notification.service';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import { Router } from '@angular/router';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { ImageResult } from 'ngx-image2dataurl';

//Service
import { BillsService } from '../../../services/bills.service';
import { FilesService } from '../../../services/files.service';
import { FleetService } from 'src/app/services/fleet.service';
import { FleetAssetsService } from 'src/app/services/fleetassets.service';


//Model
import { Bill , BillPayment, BillItem, ExpenseRecord } from '../../../model/bills.model';
import { ThemeSetting } from 'src/app/model/users.model';

@Component({
    selector: 'app-billimportexpenserecord',
    templateUrl: './billimportexpenserecord.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [ BillsService, FilesService ],
    exportAs: 'app-billimportexpenserecord',
})
  
export class BillImportExpenseRecord implements OnInit {
    @Output() imported_records : EventEmitter<any>= new EventEmitter<any>();
    @Output() done : EventEmitter<any>= new EventEmitter<any>();
    @Input() params: any;
    @Input() previous_import: ExpenseRecord[];

    
    public bi_tables: any[];

    public bi_fuels: any[];
    public bi_fuel_cards: any[];
    public bi_tyres: any[];
    public bi_insurance: any[];
    public bi_rego: any[];
    public bi_other: any[];
    public bi_services: any[];
    public bi_repairs: any[];

    private providers :any[];
    private fleets: any[];

    public fleet_name: string;
    public biller_name: string;

    public output_records: any[];

    public spinner :boolean = false;
    

    constructor(private http: HttpClient, 
    			private _fb: FormBuilder, 
    			private modal: NgbModal, 
                private svc_bills: BillsService,
			  	private toastr: NotificationService,
                private svc_storage: LocalStorageService,
                private router : Router,
                private fileService: FilesService,
                private fleetService: FleetAssetsService,
                private fleetListService: FleetService,
 				){
	}

    ngOnInit() {
      this.output_records = [];
      if(this.previous_import == null){
          this.previous_import = [];
      }else{
          this.output_records = this.previous_import;
      }

      this.getReferenceData();

      this.getImportableRecords(this.params);
    }

    public getReferenceData(){
        this.fleetListService.getFleetsForFieldDropdown().subscribe(data=>{
            this.fleets = data['fleets'];
            this.fleets.forEach(f=>{
                if (f['id'] == this.params['fleet']){
                    this.fleet_name = f['fleet_id_num'] + ' - ' + f['rego'];
                }
            })
        });

        this.fleetService.getProviders().subscribe(data=>{
            this.providers = data;
            this.providers.forEach(p=>{
                if (p['id'] == this.params['provider']){
                    this.biller_name = p['company_name'];
                }
            })
        })
    }


    public getImportableRecords(params){
        this.svc_bills.getBillTablesByBillType(this.params.bill_type).subscribe(data=>{
            this.bi_tables = data['tables'];

            this.bi_tables.forEach(table_name=>{
                this.params['table_name'] = table_name['table_name'];

                switch (table_name['table_name']){
                    case ('fuels'):{
                        this.params['date_field'] = 'date';
                        break;
                    }
                    case ('other_costs'):{
                        this.params['date_field'] = 'date';
                        break;
                    }
                    case ('fuel_cards'):{
                        this.params['date_field'] = 'activation_date';
                        break;
                    }
                    case ('tyres'):{
                        this.params['date_field'] = 'date_done';
                        break;
                    }
                    case ('services'):{
                        this.params['date_field'] = 'date_done';
                        break;
                    }
                    case ('repairs'):{
                        this.params['date_field'] = 'date_done';
                        break;
                    }
                    case ('fleet_insurance'):{
                        this.params['date_field'] = 'expiry_date';
                        break;
                    }
                    case ('rego_registrations'):{
                        this.params['date_field'] = 'expiry_date';
                        break;
                    }
                }
                
                this.svc_bills.getTableImportableRecords(this.params).subscribe(result=>{
                    switch (table_name['table_name']){
                        case ('fuels'):{
                            this.bi_fuels = result['importable_records'];
                            break;
                        }
                        case ('fuel_cards'):{
                            this.bi_fuel_cards = result['importable_records'];
                            break;
                        }
                        case ('tyres'):{
                            this.bi_tyres = result['importable_records'];
                            break;
                        }
                        case ('fleet_insurance'):{
                            this.bi_insurance = result['importable_records'];
                            break;
                        }
                        case ('rego_registrations'):{
                            this.bi_rego = result['importable_records'];
                            break;
                        }
                        case ('other_costs'):{
                            this.bi_other = result['importable_records'];
                            break;
                        }
                        case ('services'):{
                            this.bi_services = result['importable_records'];
                            break;
                        }
                        case ('repairs'):{
                            this.bi_repairs = result['importable_records'];
                            break;
                        }
                    }
                });

            })
        });

    }

    public formatDate(inDate: string) {
        let formatedDate: Date;
        if (inDate && !inDate.includes('0000') ) {
          formatedDate = new Date(inDate.replace(/-/g, "/"));
          return formatedDate;
        }
        else return null;
    }

    onSelect({ selected }, table_name) {
        console.log('Select Event', selected, table_name);
    }

    checkValue(expense_record, table_name){
        let checked = false;
    
        if(this.output_records.length){
            for(let or of this.output_records) {
                if(or['table_name'] == table_name && or['expense_record_id'] == expense_record){
                    checked =  true;break;
                }
            }
        }
        // if(this.previous_import.length){
        //     for(let pr of this.previous_import) {
        //         if(pr['table_name'] == table_name && pr['expense_record_id'] == expense_record){
        //             checked =  true;break;
        //         }
        //     }
        // }

        return checked;            
    }

    deleteRecord(expense_record , table_name){
        let index = -1;
        index= this.output_records.findIndex(x=> x.expense_record_id == expense_record.id && x.table_name == table_name);
        if(index != -1){
            this.output_records.splice(index, 1);
        }
    }

    addRecord(expense_record , table_name){
        let e_row = null;

        e_row = { 
                'bill_item_id' : this.params['bill_item_id'],
                'expense_record_id': expense_record.id,
                'table_name': table_name,
                'line_item_index' : this.params['line_item_row_index']
        }

        this.output_records.push(e_row);
    }

    setRecord(expense_record , table_name, event){
        this.spinner = true; 

        if(event.target.checked == false){
            this.deleteRecord(expense_record, table_name);
        }else{
            this.addRecord(expense_record, table_name);
        }
        setTimeout(()=>{}, 5000);
        this.spinner = false; 
        this.imported_records.emit(this.output_records);

    }

    saveImport(){
        this.imported_records.emit(this.output_records);
        this.done.emit();
    }


    
    
}